import {Component, computed, input} from '@angular/core';
import {RowComponent} from "../../row/row.component";
import {NgForOf} from "@angular/common";
import {TeamCard} from "../../model/team-card-model";
import {getTeamScoreRow} from "../../rows/team-score-row";
import {Card} from "../../model/scorecard-model";
import {ScorecardRow} from "../../rows/row";

@Component({
    standalone: true,
    selector: 'team-card',
    templateUrl: './team-card.component.html',
    imports: [
        RowComponent,
        NgForOf
    ],
    styleUrls: ['./team-card.component.css']
})
export class TeamCardComponent {
    card = input.required<Card>();

    teamCard = computed(() => {
        return this.card() as TeamCard;
    });

    rows = computed(() => {
        return [getTeamScoreRow(this.teamCard().row)]
    });

    trackByRowName(_: number, row: ScorecardRow) {
        return row.name
    }
}
